<div id="mmc-background-cost-model" class="block">

  <div >
    <div class="block">
      <label class="labelMmcBC" style="width: 140px;">
        Strategist Fee: @if (data?.usedFor !== 'custom') {
        <span class="red">*</span>
      }
      <span class="infoIcon"
      calltoaction [calltoactionTemplate]="stratFeeTemplateRef" calltoactionPosition="bottom"></span>
      <ng-template #stratFeeTemplateRef>
        This number represents the cost – in basis points – assessed to the advisor for using this
        model/product. This number does not include the underlying fund expenses that an investor will pay
        for purchasing securities included in the model's allocations.
      </ng-template>
    </label>
    <irb-number-text-box #stratFeeTxt [(value)]="data.costBPs" min="0" max="99999" places="2"
      [disabled]="disableFiled || data?.usedFor === 'custom'"
      width="70px"
    (valueChange)="validateEntries()"></irb-number-text-box>
    <span style="padding-left: 5px;">BPS</span>
  </div>

  <div>
    <span style="font-weight: bold;">Exception Strategist Fee:</span>
    <span class="infoIcon"
      calltoaction [calltoactionTemplate]="exceptionStratFeeTemplateRef"
    calltoactionPosition="bottom"></span>
    <ng-template #exceptionStratFeeTemplateRef>
      To add an exception strategist fee, click Add. Then enter the Advisor Firm Name, Master Account, and
      Exception Strategist Fee. Separate multiple Master Accounts with spaces.
    </ng-template>
    <button class="btn-medium-secondary" (click)="addStratFee()"
      [disabled]="!data.isPaidForModel || data.isProcessing || stratFeeRowDisabled">Add
    </button>

    @if (listOfFirms && !isUiTest) {
      <div>
        <irb-inventory-grid id="mmc-bc-exception-strategic-fee-grid" style="margin-top: 10px;"
          [style.height]="gridHeight"
          [showSideBar]='false'
          [gridOptions]="gridOptions"
          [componentName]="'MmcBackgroundCostModelComponent'"
          [frameworkComponents]='frameworkComponents'
          (cellValueChanged)="onCellValueChanged()"
          (gridReady)="onGridReady($event)">
        </irb-inventory-grid>
      </div>
    }
  </div>
</div>

<div class="block" style="display: flex;flex-direction: row;padding-top:10px;">

  <div style="padding-right:20px;">
    <label class="labelMmcBCBottom">
      Asset type: @if (data?.usedFor !== 'custom') {
      <span class="red">*</span>
    }
    <span class="infoIcon"
    calltoaction [calltoactionTemplate]="assetTypeTemplateRef" calltoactionPosition="bottom"></span>
    <ng-template #assetTypeTemplateRef>
      Enter the type of assets contained in this model from the list. This will help advisors understand
      how the model is constructed.
    </ng-template>
  </label>
  <irb-dropdown-filter #IrbDropdownAssetType (search)="getAssetTypes($event)" size="15"
    [disabled]="disableFiled"
    [value]="assetType" hoverPanelWidth="180"
  (selection)="onAssetTypeChange($event)"></irb-dropdown-filter>
</div>

<div >
  <label class="labelMmcBCBottomSugMin">
    Suggested minimum:
    <span class="infoIcon"
      calltoaction [calltoactionTemplate]="suggestedMinTemplateRef"
    calltoactionPosition="bottom"></span>
    <ng-template #suggestedMinTemplateRef>
      You have the option to suggest an investment minimum for this model. This will be displayed to
      advisors, but the iRebal system will not force advisors to adhere to this minimum.
    </ng-template>
  </label>
  <span style="width: 10px;">$&nbsp;</span>

  <irb-number-text-box #suggestedMinTxt [(value)]="this.data.suggestedMinimum" min="0" max="999999999"
    places="0"
    [disabled]="disableFiled || data?.usedFor === 'custom'"
    width="90px"
  (valueChange)="validateEntries()"></irb-number-text-box>
</div>
</div>

</div>
